(function () {
    'use strict';

    angular
        .module('rms.common')
        .factory('action-rms-get-selected-dataitem', actionFunc);

    function actionFunc($q, ListFilterStateFactory, lodash) {
        return function(options) {
            return $q.when(run());
            function run() {
                const listFilterIdentifier = lodash.get(options, 'identifier', null);
                const listFilterService = ListFilterStateFactory.get(listFilterIdentifier);
                if (listFilterService === null) return false;
                return listFilterService.getSelectedModel(options.include_select_filters);
            }
        };
    }
})();
